import actionTypes from '@atom/actions/actionTypes';

import initialState from './initialState';

export default function workTemplatesTotalReducer(
  state = initialState.workTemplatesTotal,
  action,
) {
  switch (action.type) {
    case actionTypes.GET_WORK_TEMPLATES_TOTAL_SUCCESS: {
      return action.data ? action.data : 0;
    }
    default: {
      return state;
    }
  }
}
